import { createContext, type ReactNode,useContext } from "react";

const ReportingTimezoneContext = createContext<string>("UTC");

export function ReportingTimezoneProvider({
  timeZone,
  children,
}: {
  timeZone: string;
  children: ReactNode;
}) {
  return (
    <ReportingTimezoneContext.Provider value={timeZone}>{children}</ReportingTimezoneContext.Provider>
  );
}

export function useReportingTimezone(): string {
  return useContext(ReportingTimezoneContext);
}
